import GlobalData from './GlobalData.js'
import el from "element-ui/src/locale/lang/el";

/**
 * 在该文件中定义全局过滤器，在需要用到过滤器的页面对应的 main.js 中引入， 并注册全局过滤器
 */
const dfilters = {
    /**
     * 空值处理
     */
    valNullHandler : function(value, placeholder) {
        if (value == null || (value+"").length < 1) return placeholder ? placeholder:" -- ";
        else return value;
    },
    /**
     * 数字空值处理
     */
    valNumberNullHandler : function(value, placeholder) {
        if (value == null || (value+"").length < 1 || isNaN(value)) return placeholder ? placeholder:" -- ";
        else return value;
    },
    /**
     * 数字最大值处理，超过1000显示999+
     */
    valNumberMaxHandler : function(value, placeholder) {
        if (value == null || (value+"").length < 1 || isNaN(value)) {
            return placeholder ? placeholder:" -- ";
        }
        else if (value >= 1000) {
            return '999+';
        }
        else return value;
    },
    /**
     * 英文单复数处理（包含值），超过1显示复数形式
     */
    durationTypeHandler : function(value, placeholderSingular, placeholderPlural) {
        if (value == null || (value+"").length < 1 || isNaN(value)) {
            return " -- ";
        }
        else if (value > 1) {
            //复数形式
            return value+" "+placeholderPlural;
        }
        else return value+" "+placeholderSingular;
    },
    /**
     * 英文单复数处理（不包含值），超过1显示复数形式
     */
    durationTypeWithoutValHandler : function(value, placeholderSingular, placeholderPlural) {
        if (value == null || (value+"").length < 1 || isNaN(value)) {
            return placeholderSingular;
        }
        else if (value > 1) {
            //复数形式
            return placeholderPlural;
        }
        else return placeholderSingular;
    },
    /**
     * 新闻全局过滤器
     */
    newsCoverUrlFilter: function (value) {
        //console.log(value)

        if (value && ((value.indexOf("http://") >= 0) || (value.indexOf("https://") >= 0))) {
            return value
        }
        else if (!value || value.length == 0) {
            return ""
        }
        else
        {
            return GlobalData.OSS_BASE_URL+value
        }
    },
    /**
     * 新闻内容过滤器
     */
    newsSmallTitleFilter: function (value) {
        if (value && value.length > 60) {
            return value.substr(0, 60) + '...'
        } else {
            return value
        }
    },
    /**
     * 新闻近期文章标题过滤器
     */
    newsRecentTitle: function (value) {
        if (value && value.length > 30) {
            return value.substr(0, 30) + '...'
        } else {
            return value
        }
    }
}
export default dfilters;
